<template>
  <div
    ref="pagesContainer"
    v-resize="setContainerWidth"
    class="WatermarkedDocumentsViewer"
    :class="{'WatermarkedDocumentsViewer--loading': init}"
  >
    <template v-if="init">
      <AppLoader/>
    </template>
    <template v-else>
      <WatermarkedDocumentsPage
        v-for="index in totalPages"
        :key="`watermarkedPage-${index}`"
        :page="index"
        :mnemo="mnemo"
        :pages-container-width="pagesContainerWidth"
        :max-container-width="MAX_CONTAINER_WIDTH"
        data-locator="watermarked-page"
        @getWatermarkedPages="prepareGetWatermarkedFile"
      />
    </template>
  </div>
</template>

<script>
import { debounce } from 'lodash-es'
import { mapActions, mapState } from 'vuex'

import AppLoader from '@/common/AppLoader.vue'
import { toast } from '@/common/utils/toast'
import { FilesActionTypes } from '@/store/modules/files/action_types'
import { FilesMutationTypes } from '@/store/modules/files/mutation_types'

import WatermarkedDocumentsPage from './WatermarkedDocumentsPage.vue'
const PAGES_REQUEST_DEBOUNCE_TIMER = 1000
const CONTAINER_RESIZE_DEBOUNCE_TIMER = 500
const MAX_CONTAINER_WIDTH = 1000
export default {
  name: 'WatermarkedDocumentsViewer',
  components: {
    WatermarkedDocumentsPage,
    AppLoader,
  },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    fileId: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      MAX_CONTAINER_WIDTH,
      requestedPages: {
        startPage: 1,
        endPage: 3,
      },
      init: true,
      pagesContainerWidth: MAX_CONTAINER_WIDTH,
    }
  },
  computed: {
    ...mapState('files', ['watermarkedFile']),
    totalPages () {
      if (this.watermarkedFile) {
        return this.watermarkedFile.totalNbPages
      }
      return 0
    },
  },
  created () {
    this.prepareGetWatermarkedFile({
      pagesToRequest: this.requestedPages,
      fileId: this.fileId,
    })
    this.prepareGetWatermarkedFile = debounce(this.prepareGetWatermarkedFile, PAGES_REQUEST_DEBOUNCE_TIMER)
    this.setContainerWidth = debounce(this.setContainerWidth, CONTAINER_RESIZE_DEBOUNCE_TIMER)
  },
  beforeUnmount () {
    this.$store.commit(`files/${FilesMutationTypes.RESET_WATERMARKED_FILE}`)
  },
  methods: {
    ...mapActions('files', [FilesActionTypes.GET_WATERMARKED_FILE]),
    async prepareGetWatermarkedFile ({ pagesToRequest, fileId }) {
      try {
        await this.GET_WATERMARKED_FILE({
          mnemo: this.mnemo,
          fileId,
          data: { ...pagesToRequest },
        })
      } catch (error) {
        toast.error(this.$t('project.documents.watermarked-viewer.WatermarkedDocumentsViewer.getWatermarkedFileError'))
      } finally {
        this.init = false
      }
    },
    setContainerWidth () {
      const containerStyles = window.getComputedStyle(this.$refs.pagesContainer)
      const paddingToSubstract = parseFloat(containerStyles.paddingLeft) + parseFloat(containerStyles.paddingRight)
      this.pagesContainerWidth = this.$refs.pagesContainer.clientWidth - paddingToSubstract
    },
  },
}
</script>

<style scoped lang="scss">
.WatermarkedDocumentsViewer {
  &--loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
</style>
